import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { toast } from 'react-toastify';

import { createWorkout } from '~/api';

import { Button } from '~/components/_layouts/forms/styles';
import Dialog from '~/components/Dialog';
import {
  SDialogTitle,
  ActionButtonSection,
  defaultFieldProps,
} from '../../components/Dialog/styles';
import Loading from '~/components/Loading';

const FORM_INITIAL_VALUES = {
  name: null,
  observations: null,
};

export default function NewWorkoutDialog({
  isOpen,
  setIsOpen,
  trainingRoutineId,
  orderedIndex,
  refreshWorkouts,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const trainingRoutine = { id: trainingRoutineId };
      await createWorkout({ ...values, orderedIndex, trainingRoutine });
      toast.success('Ficha criada com sucesso!');

      refreshWorkouts();
    } catch (error) {
      toast.error('Ops, não foi possivel criar uma nova ficha!');
    } finally {
      setIsLoading(false);
      setIsOpen(false);
    }
  };

  return (
    <Dialog open={isOpen}>
      <SDialogTitle>Nova Ficha</SDialogTitle>
      <Formik initialValues={FORM_INITIAL_VALUES} onSubmit={handleSubmit}>
        <Form>
          <div>
            <Field
              name="name"
              required
              label="Nome da ficha"
              {...defaultFieldProps}
            />
            <Field
              name="observations"
              label="Observações"
              {...defaultFieldProps}
            />
          </div>

          <ActionButtonSection>
            <Button
              disabled={isLoading}
              type="button"
              cancelButton
              onClick={() => setIsOpen(false)}
            >
              Cancelar
            </Button>
            <Button disabled={isLoading} type="submit">
              Criar
              {isLoading && <Loading buttonLoading />}
            </Button>
          </ActionButtonSection>
        </Form>
      </Formik>
    </Dialog>
  );
}

NewWorkoutDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  trainingRoutineId: PropTypes.number.isRequired,
  orderedIndex: PropTypes.number.isRequired,
  refreshWorkouts: PropTypes.func.isRequired,
};
